import { render, staticRenderFns } from "./activity_presell_edit.vue?vue&type=template&id=23c08b6a&scoped=true"
import script from "./activity_presell_edit.vue?vue&type=script&lang=js"
export * from "./activity_presell_edit.vue?vue&type=script&lang=js"
import style0 from "./activity_presell_edit.vue?vue&type=style&index=0&id=23c08b6a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c08b6a",
  null
  
)

export default component.exports